import React from 'react';
import { Box, Text } from '@wix/design-system';
import { SaleBanner } from '@wix/premium-purchase-platform/@components';
import { Time } from '@wix/wix-ui-icons-common';
import s from './SalesPromotion.scss';
export const SalesPromotion = () => {
  return /*#__PURE__*/React.createElement(SaleBanner.Root, null, _ref => {
    let {
      data,
      isError,
      isLoading
    } = _ref;
    const {
      timeLeft,
      saleType
    } = data || {};
    if (isError || isLoading || !saleType) {
      return null;
    }
    return /*#__PURE__*/React.createElement(SaleBanner.Container, null, /*#__PURE__*/React.createElement(Box, {
      gap: 1,
      className: s.container
    }, /*#__PURE__*/React.createElement(Time, null), /*#__PURE__*/React.createElement(Text, null, "Limited time offer - Save 50% off on selected plans"), timeLeft && timeLeft.days === 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SaleBanner.Seperator, null), /*#__PURE__*/React.createElement(Box, {
      width: "150px"
    }, /*#__PURE__*/React.createElement(Text, {
      weight: "bold"
    }, [(timeLeft == null ? void 0 : timeLeft.hours) || 0, (timeLeft == null ? void 0 : timeLeft.minutes) || 0, (timeLeft == null ? void 0 : timeLeft.seconds) || 0].join(' : ')))) : null));
  });
};
//# sourceMappingURL=SalesPromotion.js.map